"use client";

import { ActionIcon, Loader, TextInput } from "@mantine/core";
import { useEffect, useState, useTransition } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { useDebouncedValue } from "@mantine/hooks";
import Image from "next/image";
import { mediaUrl } from "@/lib/config/app";
export default function SearchBar({
  dark,
  shop
}) {
  const [query, setQuery] = useState("");
  const [isPending, startTransition] = useTransition();
  const [debounced] = useDebouncedValue(query, 300);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [focused, setFocused] = useState(false);
  const router = useRouter();
  const searchParams = useSearchParams();
  const urlQuery = searchParams.get("q") || "";
  const [stags, setStags] = useState([]);
  const [sbrands, setSbrands] = useState([]);
  const [scats, setScats] = useState([]);
  const [sloading, setSloading] = useState(false);
  let defaultRadius = "sm";
  if (shop.theme.radius === '16px') {
    defaultRadius = "xl";
  } else if (shop.theme.radius === '8px') {
    defaultRadius = "lg";
  } else if (shop.id === "aspireeciguk") {
    defaultRadius = "xl";
  }
  const headerStyle = shop.theme.header.layout;
  let orderPosition;
  let searchWidth;
  if (headerStyle === 'minimal') {
    orderPosition = "order-3 lg:order-2";
    searchWidth = "w-full lg:flex-1 lg:min-w-87.5";
  } else if (headerStyle === 'center-logo') {
    orderPosition = "order-3 lg:order-0";
    searchWidth = "w-full";
  } else {
    orderPosition = "order-3 lg:order-2";
    searchWidth = "w-full lg:flex-1 lg:min-w-87.5";
  }
  useEffect(() => {
    async function fetchTags() {
      try {
        setSloading(true);
        const resp = await fetch('/api/products/searchtags');
        const data = await resp.json();
        setStags(data?.searchtags || []);
        setSbrands(data?.searchbrands || []);
        setScats(data?.searchcats || []);
      } catch (e) {
        console.error(e);
      } finally {
        setSloading(false);
      }
    }
    fetchTags();
  }, []);

  /* eslint-disable react-hooks/set-state-in-effect */
  useEffect(() => {
    if (!focused) {
      setQuery(urlQuery);
    }
  }, [urlQuery, focused]);
  useEffect(() => {
    if (!debounced) {
      setResults([]);
      return;
    }
    setLoading(true);
    fetch(`/api/products/search?q=${encodeURIComponent(debounced)}`).then(res => res.json()).then(data_0 => {
      setResults(data_0?.products?.products || []);
    }).catch(e_0 => {
      console.error(e_0);
      setResults([]);
    }).finally(() => {
      setLoading(false);
    });
  }, [debounced]);
  /* eslint-enable react-hooks/set-state-in-effect */

  const handleSearch = value => {
    if (!value.trim()) return;
    startTransition(() => {
      router.push(`/search?q=${encodeURIComponent(value.trim())}`);
      setResults([]);
      setFocused(false);
    });
  };
  return <div className={`search-bar ${searchWidth} ${headerStyle} ${orderPosition}`}>
            <div className="relative">
                <TextInput radius={`${defaultRadius}`} size={'md'} value={query} onChange={e_1 => setQuery(e_1.currentTarget.value)} onKeyDown={e_2 => {
        if (e_2.key === "Enter") handleSearch(query);
      }} rightSection={<ActionIcon color={'var(--color-primary)'} radius={defaultRadius} onClick={() => handleSearch(query)} className="cursor-pointer flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--mdi" fontSize="20" width="1em" height="1em" viewBox="0 0 24 24">
                                <path fill="currentColor" d="M9.5 3A6.5 6.5 0 0 1 16 9.5c0 1.61-.59 3.09-1.56 4.23l.27.27h.79l5 5l-1.5 1.5l-5-5v-.79l-.27-.27A6.52 6.52 0 0 1 9.5 16A6.5 6.5 0 0 1 3 9.5A6.5 6.5 0 0 1 9.5 3m0 2C7 5 5 7 5 9.5S7 14 9.5 14S14 12 14 9.5S12 5 9.5 5"></path>
                            </svg>
                        </ActionIcon>} rightSectionPointerEvents="all" placeholder={'Search for products & brands...'} leftSection={<div className="w-4 flex justify-center">{(loading || isPending) && <Loader size="xs" />}</div>} onFocus={() => setFocused(true)} onBlur={() => setTimeout(() => setFocused(false), 200)} />
                {focused && !results.length && <div className={'absolute left-0 right-0 bg-white border border-gray-300 rounded-lg mt-1 p-2 z-1000 top-full'}>
                        {stags?.length > 0 && <div className={'grid grid-cols-1 lg:grid-cols-3 gap-3'}>
                                <div className="flex flex-col gap-2">
                                    <div className={`${dark ? 'text-black' : 'text-black'} font-heading text-base underline underline-offset-4 decoration-primary decoration-2`}>Popular Searches</div>
                                    <div className={'flex flex-wrap lg:flex-col gap-2'}>
                                        {stags?.map((tag, index) => <div className={'cursor-pointer capitalize text-[11px] font-medium max-w-fit rounded-xl px-2 py-1 border-2 border-primary bg-primary/5 text-black'} key={index} onClick={() => router.push(`/${tag.link}`)}>
                                                {tag.title}
                                            </div>)}
                                    </div>
                                </div>
                                {sbrands?.length > 0 && <div className="flex flex-col gap-2">
                                        <div className={`${dark ? 'text-black' : 'text-black'} font-heading text-base underline underline-offset-4 decoration-primary decoration-2`}>Popular Brands</div>
                                        <div className={'flex flex-wrap lg:flex-col gap-2'}>
                                            {sbrands?.map((brand, index_0) => <div className={'cursor-pointer capitalize text-[11px] font-medium max-w-fit rounded-xl px-2 py-1 border-2 border-primary bg-primary/5 text-black'} key={index_0} onClick={() => router.push(`/${brand.link}`)}>
                                                    {brand.title}
                                                </div>)}
                                        </div>
                                    </div>}
                                {scats?.length > 0 && <div className="flex flex-col gap-2">
                                        <div className={`${dark ? 'text-black' : 'text-black'} font-heading text-base underline underline-offset-4 decoration-primary decoration-2`}>Popular Collections</div>
                                        <div className={'flex flex-wrap lg:flex-col gap-2'}>
                                            {scats?.map((cat, index_1) => <div className={'cursor-pointer capitalize text-[11px] font-medium max-w-fit rounded-xl px-2 py-1 border-2 border-primary bg-primary/5 text-black'} key={index_1} onClick={() => router.push(`/${cat.link}`)}>
                                                    {cat.title}
                                                </div>)}
                                        </div>
                                    </div>}
                            </div>}
                    </div>}
                {focused && results.length > 0 && <div className={`${dark ? 'text-black' : 'text-black'} grid grid-cols-1 lg:grid-cols-2 gap-1 absolute left-0 right-0 bg-white rounded-lg p-1 mt-1 z-250 shadow/10 overflow-hidden`}>
                        {results.slice(0, 8).map(p => <div className={'pcard py-2 px-4 cursor-pointer border border-gray-50 shadow rounded-lg bg-white hover:bg-gray-50'} key={p.product_id} onClick={() => router.push(`/products/${p.handle}`)}>
                                <div className={'flex gap-2'}>
                                    <div className={'relative aspect-square w-12 lg:w-16 h-12 lg:h-16 shadow rounded-lg overflow-hidden'}>
                                        <Image src={`${mediaUrl}${p?.featured_image || "noimage.png"}`} alt={p.title} fill sizes={'50vw'} style={{
                objectFit: 'contain'
              }} />
                                    </div>
                                    <div>
                                        <div className={'text-xs lg:text-sm'}>{p.title}</div>
                                        {p?.compareprice > p.price ? <div className={'font-heading'}><span className={'cred me-1'}>£{p.price}</span> <del className={'text-sm'}>£{p.compareprice}</del></div> : <div className={'font-heading'}>£{p.price}</div>}
                                    </div>
                                </div>
                            </div>)}
                    </div>}
            </div>
        </div>;
}